import React from 'react'
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
const Footer = ({setCursorVariant}) => {
    return (
        <footer>
            <div className="container footer">
                <div className="me ">
                    
                    <div className='tt'>
                        abdelrahmanadelsaleh9@gmail.com<br />
                        whatsapp: +201551560607<br />
                        phone Number: +201551560607
                    </div>
                </div>
                <div className="row ">
                <div className="icons">
                        <a rel="noreferrer" target='_blank' href="https://github.com/NETEROabdelrahman"><i className="fa-brands fa-github"></i></a>
                        <a rel="noreferrer" target='_blank' href="https://www.linkedin.com/in/abdelrahman-adel-91a0a3223/"><i className="fa-brands fa-linkedin"></i></a>
                        
                    </div>
                    
                </div>
            </div>
            <p className=' text-center p-5'>No Copyright 2023 • abdelrahman adel <span>designed and developed by me</span> </p>
        </footer>
    );
}

export default Footer